import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { resourceServerUrl } from '../constants/server-settings';

@Injectable({
  providedIn: 'root',
})
export class FeatureAccessService  {
  private hasAccess$ = new BehaviorSubject<any | null>(null);

  constructor(private http: HttpClient) {}

  checkAccess(): Observable<any> {
    const cachedValue = this.hasAccess$.getValue();
    
    if (cachedValue) {
      return of(cachedValue);
    }

    return this.http.get(`${resourceServerUrl}/v1/user/profile/info`).pipe(
      map((res: any) => {
        const {status, menuJson, resetRequired} = res;
        return {status, menuJson, resetRequired};
      }),
      tap((permission: any) => this.hasAccess$.next(permission)),
      catchError(() => {
        this.hasAccess$.next(null);
        return of(null);
      })
    );
  }

}
